<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!showAddAnexo">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Coleta</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objView.xsequencia }}</div>
                </div>            

                <div class="form-item-char10">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.amostra_dtcolheita) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label">{{ objView.nmestabelecimento }}</div>
                </div>

                <div class="form-item-char30">
                    <label class="label-caption">Responsável</label>
                    <div class="field-label">{{ objView.nmresponsavel }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Categoria</label>
                    <div class="field-label">{{ objView.xamostra_categoria }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome oficial</label>
                    <div class="field-label">{{ objView.amostra_nmoficial }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome comercial</label>
                    <div class="field-label">{{ objView.amostra_nmcomercial }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Marca</label>
                    <div class="field-label">{{ objView.amostra_marca }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Quantidade</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.amostra_qtd) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Temperatura</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.amostra_temperatura) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Lote</label>
                    <div class="field-label">{{ objView.amostra_lote }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Validade</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.amostra_validade) }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Lacre</label>
                    <div class="field-label field-label-center">{{ objView.amostra_lacre }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Lacre SIM</label>
                    <div class="field-label field-label-center">{{ objView.amostra_lacre_sim }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Lacre Empresa</label>
                    <div class="field-label field-label-center">{{ objView.amostra_lacre_empresa }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char30">
                    <label class="label-caption">Local</label>
                    <div class="field-label">{{ objView.amostra_local_colheita }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Fiscalizatória</label>
                    <div class="field-label field-label-center">{{ objView.tpfiscalizatoria }}</div>
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Corretiva</label>
                    <div class="field-label field-label-center">{{ objView.tpcorretiva }}</div>
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">REF</label>
                    <div class="field-label field-label-center">{{ objView.tpref }}</div>
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Auto Cont.</label>
                    <div class="field-label field-label-center">{{ objView.tpautocontrole }}</div>
                </div>
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <div class="field-label">{{ objView.analise_obs }}</div>
                </div>
            </div>
            

            <div class="row row-space">
                <div class="form-item-char40">
                    <label class="label-caption">Responsável presente</label>
                    <div class="field-label">{{ objView.xtpresponsavel }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">SIM</label>
                    <div class="field-label">{{ objView.nmsim }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Coletor</label>
                    <div class="field-label">{{ objView.nmcoletor }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Responsável envio</label>
                    <div class="field-label">{{ objView.xresponsavel_envio }}</div>
                </div>
            </div>
            
            
            <div class="row-end">
                <button type="button" @click="visualizarLaudo">Termo de Coleta</button>
                <button v-if="globalStore.ckperfilinspetor" type="button" @click="showAddAnexo=true">Anexar Resultado</button>
                <button type="button" @click="closeForm">Retornar</button>
            </div>
        </div>

        
        <div v-if="lsAnexos.length>0" class="table-wrapper row-space">
            <table>
                <thead><tr>
                    <th>Resultado</th>
                    <th>Laboratório</th>
                    <th>Identificação</th>
                    <th>Resultado</th>
                    <th></th>
                </tr></thead>
                <tbody>
                    <template v-for="(obj, index) in lsAnexos" :key="obj.id">
                        <tr :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                            <td class="col-width-char15 center">{{ Funcoes.formatDateFromJson(obj.dtresultado) }}</td>
                            <td>{{ obj.nmlaboratorio }}</td>
                            <td class="col-width-char40">{{ obj.identificacao }}</td>
                            <td class="col-width-char20">{{ obj.nmresultado }}</td>
                            <td class="col-width-char10"><div class="row-left">
                                <button class="btn-icon btn-icon--pdf" @click="visualizarResultado(obj)"></button>
                                <button v-if="globalStore.ckperfilinspetor && globalStore.ckperfilinspetor"
                                    class="btn-icon btn-icon--trash" @click="estornarResultado(obj)"></button>
                            </div></td>
                        </tr>


                        <!-- Linha extra para observações -->
                        <tr v-if="obj.obspostagem">
                            <td colspan="5" class="obs-cell">
                                <strong>Observações:</strong>
                                <pre>{{ obj.obspostagem }}</pre>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        

        <div v-if="lsNc.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Análise</th>
                    <th>Tipo</th>
                    <th>Informações</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsNc" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-char30">{{ obj.nmanalise }}</td>
                        <td class="col-width-char10 center">{{ obj.tpanalise }}</td>
                        <td>{{ obj.informacoes }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <div v-if="showAddAnexo">
        <AnexoUploadPage :idAnexoGrupo="3" :objReferencia="objView" @close="showAddAnexo = false" @salvo="lerAnexos" />
    </div>
    

    <SenhaModal ref="senhaModalRef" />

</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import AnexoUploadPage from '@/components/operacoes/AnexoUploadPage.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const isLoading = ref(false);
const lsAnexos = ref([]);
const lsNc = ref([]);
const msgAlerta=ref(null);
const objView = ref({});
const showAddAnexo = ref(false);


const closeForm = () => {emit('close');}


async function estornarResultado(obj){
    try{
        msgAlerta.value=null;
        console.log(obj);

        // Validacoes.validarTexto(edJustificativa.value, 'Necessário informar justificativa');

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        /*
        isLoading.value = true;

        // REGISTRAR ASSINATURA
        const objAssinatura = criarAssinatura();
        objAssinatura.idep            = globalStore.idep;
        objAssinatura.idusuario       = globalStore.idusuario;
        objAssinatura.idsessao        = globalStore.idlogin;
        objAssinatura.nmusuario       = globalStore.nmusuario;
        objAssinatura.vssistema       = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.ass_conteudo    = `REF:DOCANULACAO|IDREF:${objView.value.id}|PROT:${objView.value.protocolo}`;
        objAssinatura.ass_senha       = senhaDigitada;
        objAssinatura.ass_tipoauth    = 'senha pessoal via sistema WEB';
        objAssinatura.doc_idorigem    = objView.value.refid;
        objAssinatura.doc_tipo        = 'DOCANULACAO';
        const respAss = await Api.genericPut('/doc/assinar', objAssinatura);
        if (respAss.bolok != 1) throw new Error(`ATENÇÃO: ${respAss.erro}`);

        // GRAVAR DADOS DE HOMOLOGAÇÃO
        const respDoc = await Api.genericPut('/doc/docanulacao', {
            id: objView.value.id,
            idhomologacao: respAss.id,
            ckhomologacao: ckAprovar ? 'S' : 'N',
            jshomologacao: edJustificativa.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario
        });
        if (respDoc.bolok != 1) throw new Error(`ATENÇÃO: ${respDoc.erro}`);

        // EXECUTAR ROTINA DE HOMOLOGAÇÃO
        const respExec = await Api.genericPost('/doc/exec_requisicao', {
            id: respDoc.id,
            idep: globalStore.idep,
            nmrequisicao: 'SPDOCANULACAO_HOMOLOGAR',
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin});

        if (respExec.bolok==1){
            lerDados();
        }else{throw new Error(respExec.erro)}*/
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function lerAnexos(){
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/lspla/pla01/resultados', {idep: globalStore.idep, idreferencia: objView.value.id});
        lsAnexos.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lspla/pla01', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);
        lerAnexos();
        lerNC();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function lerNC(){
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/lspla/pla01/nc', {idep: globalStore.idep, idreferencia: objView.value.id});
        lsNc.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


const visualizarLaudo = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lspla/pla01_anexo_base64', {id:0, idreferencia: props.idView, strparam1: 'L'});
        const pdfBase64 = req.anexo;
        const pdfWindow = window.open("");
        const iframe = pdfWindow.document.createElement("iframe");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.src = "data:application/pdf;base64," + encodeURIComponent(pdfBase64);
        pdfWindow.document.body.appendChild(iframe);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function visualizarResultado(obj){
    try {
        msgAlerta.value = null;
        isLoading.value = true;        
        if (obj.storage_cdtipo === 2){
            const r = await Api.genericPost('/operacoes/solicitar/download', {id: obj.idanexo});
            if (r.bolok === 1){
                const url = r.download_url;
                window.open(url, '_blank');
            }
        }else{
            const response = await Api.genericAnexo(obj.idanexo);
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

onMounted(lerDados);
</script>